import styled, { css } from 'styled-components';
import { colors, ApMenu } from '@alixpartners/ui-components';

export const StyledMenu = styled(ApMenu)`
	padding-bottom: 0 !important;
	max-width: 400px !important;
	overflow: hidden !important;
	max-height: calc(100% - 144px) !important;
	display: flex;

	margin-top: 7px;
	margin-left: -5px;
	${({ offsetRight }) =>
		offsetRight ? `margin-right: ${offsetRight}px;` : 'margin-right: -5px;'};
`;

export const Wrapper = styled.div`
	display: flex;
	flex-direction: column;
	max-height: 100%;
	${({ width }) => `width:${width || 300}px`};
`;

export const SearchWrapper = styled.div`
	> div {
		height: 40px;
	}

	button.ap-simple-search-search,
	button.ap-simple-search-clear {
		top: 11px;

		svg {
			fill: ${colors.grey6};
		}
	}

	input {
		border-radius: 0;
		border-color: ${colors.grey4};
		height: 40px;

		&:focus:enabled,
		& ~ button:focus:enabled {
			box-shadow: none;
		}

		&:focus,
		&:hover {
			border-color: ${colors.green2};
		}

		&:active {
			border-color: ${colors.green3};
		}

		&:disabled {
			pointer-events: none;
			color: ${colors.grey5};
			border-color: ${colors.grey2};
		}
	}
`;

export const ListItem = styled.div`
	width: 100%;
	display: flex;
	align-items: center;
	min-height: 40px;
	padding: 0 24px 0 32px;

	&.active,
	&:focus,
	&:hover {
		background-color: ${colors.lightGreen1};
	}
`;

export const ListTitle = styled.div`
	color: ${colors.grey4};
	span {
		color: ${colors.grey8};
	}
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
	padding-right: 12px;
`;

export const ListInfo = styled.div`
	color: ${colors.grey5};
	margin-left: auto;
	font-size: 13px;
	letter-spacing: 0.3px;
`;

export const List = styled.div`
	padding: 8px 0;
	overflow: auto;
	max-height: 240px;

	${({ direction }) =>
		direction === 'up'
			? css`
					position: absolute;
					bottom: 48px;
					background: white;
					width: 420px;
					border: 1px solid grey;
			  `
			: ''};
`;
